// extracted by mini-css-extract-plugin
export default {"label":"RelationshipTranslation_label__5s+nq","link":"RelationshipTranslation_link__xNRzK"};